import { t } from 'i18next';

import { CustodialWalletTransactionStatus } from 'types/custodialWallet';

import { makeLabels } from 'utils/i18n';

const NAMESPACE = 'components.pwcRefundTransactionBadge';
export const LABELS = makeLabels(
  {
    STATUS: {
      [CustodialWalletTransactionStatus.Failed]: ['failed', 'Failed'],
      [CustodialWalletTransactionStatus.Submitted]: ['submitted', 'Submitted'],
      [CustodialWalletTransactionStatus.Completed]: ['completed', 'Completed'],
    },
  },
  NAMESPACE,
);

export const badgePropsMap: Record<CustodialWalletTransactionStatus, { type: CustodialWalletTransactionStatus; label: string }> = {
  [CustodialWalletTransactionStatus.Failed]: {
    type: CustodialWalletTransactionStatus.Failed,
    label: t(LABELS.STATUS[CustodialWalletTransactionStatus.Failed]),
  },
  [CustodialWalletTransactionStatus.Submitted]: {
    type: CustodialWalletTransactionStatus.Submitted,
    label: t(LABELS.STATUS[CustodialWalletTransactionStatus.Submitted]),
  },
  [CustodialWalletTransactionStatus.Completed]: {
    type: CustodialWalletTransactionStatus.Completed,
    label: t(LABELS.STATUS[CustodialWalletTransactionStatus.Completed]),
  },
};
